export default __webpack_public_path__ + "static/MyM-keyart-static-8bd5a97a59d83ae49061a2ae06c20acd.jpg";